// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4p-2";
export var blackBorderOnHover = "_4p-7";
export var cell = "_4p-6";
export var cellContainer = "_4p-3";
export var checked = "_4p-8";
export var disabled = "_4p-5";
export var featuredIconCellContainer = "_4p-9";
export var featuredIconTextContainer = "_4p-b";
export var featuredIconWrapper = "_4p-a";
export var noBorder = "_4p-c";
export var orangeSelectedRow = "_cd-3";
export var overflowableText = "_4p-0";
export var overflowableTextContainer = "_4p-1";
export var row = "_4o-0";
export var rowCheckboxCell = "_4p-4";
export var selectableTable = "_cd-2";